/* istanbul ignore file */
import { lifecycle } from 'recompose'

import createEnvironment from 'config/env'

const environment = createEnvironment()

export const withLogVersion = lifecycle({
  componentDidMount() {
    const tag: string = environment.get('release')

    /* eslint-disable no-console -- we use these logs to determine the version/build of the app we are on */
    if (!tag) {
      console.info(
        `%c No "RELEASE_TAG" environment variables were found to show here!`,
        'background: rgba(255,255,255,0.1); color: #FA2A2B;',
      )
    } else {
      console.info(`%c Running application version (${tag})`, 'background: #222; color: #57c7e8;')
    }
    /* eslint-enable no-console */
  },
})
